import React, { Component } from 'react';
import { withRouter, } from 'react-router-dom';
import Cookies from 'js-cookie';
import sha256 from 'js-sha256';

import {
    updateProfile,
    generateCookieData
} from '../services/webServices';

class UserFormData extends Component {
    state = {
        fields: { firstname: '', lastname: '', emailid: '' },
        errors: {},
        errorMessage: ""
    }
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.submituserRegistrationForm = this.submituserRegistrationForm.bind(this);
        this.OnClickContinueWithoutLogin = this.OnClickContinueWithoutLogin.bind(this);
    }


    handleChange(e) {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });

    }

    async submituserRegistrationForm(e) {
        e.preventDefault();
        if (this.validateForm()) {
            let fields = {};
            fields["firstname"] = "";
            fields["lastname"] = "";
            fields["emailid"] = "";
            this.setState({ fields: fields });
            let profileResponse = await updateProfile(this.prepareUserData(this.state.fields), this.props.profileApi);

            if (profileResponse.status === 200 && profileResponse.data && Object.keys(profileResponse.data).length !== 0) {
                this.props.cookieObj.hashedEmail = sha256(this.state.fields.emailid);
                let cookieData = generateCookieData(this.props.cookieObj);
                document.cookie = `esri_auth=${cookieData}; expires=${this.props.expirationDate.toUTCString()}; path=/; domain=${this.props.domain}` + this.props.secureOption;
                //Cookies.set('esri_auth', cookieData, { expires: this.props.expirationDate, path:'/', domain:this.props.domain});
                if(this.props.cartId){
                    Cookies.set('eCommCartId', this.props.cartId, {expires: this.props.expirationDate, path: '/', domain: this.props.domain});
                }
                window.location.replace(this.props.redirectSuccess);
            } else {
                // Hide the formdata
                document.getElementById('formdata').style.display = 'none';
                // Set the error message in the state
                this.setState({ errorMessage: (this.props.labelData.updateProfileErrorMessage)});
            }
        }

    }

    OnClickContinueWithoutLogin() {
        window.location.replace(this.props.redirectSuccess);
    }

    prepareUserData(formData) {
        return {
            'primaryEmail': formData.emailid,
            'userName': this.props.cookieObj.userName,
            'firstName': formData.firstname.trim(),
            'lastName': formData.lastname.trim(),
            'token' : this.props.cookieObj.token

        }
    }

    validateForm() {

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!fields["firstname"].trim()) {
            formIsValid = false;
            errors["firstname"] = this.props.labelData.firstNameValidation;
        }

        if (typeof fields["firstname"] !== "undefined") {
            if (fields["firstname"].length > 40) {
                formIsValid = false;
                errors["firstname"] = this.props.labelData.maxlength;
            }
        }

        if (!fields["lastname"].trim()) {
            formIsValid = false;
            errors["lastname"] = this.props.labelData.lastNameValidation;
        }

        if (typeof fields["lastname"] !== "undefined") {
            if (fields["lastname"].length > 40) {
                formIsValid = false;
                errors["lastname"] = this.props.labelData.maxlength;
            }
        }

        if (!fields["emailid"].trim()) {
            formIsValid = false;
            errors["emailid"] = this.props.labelData.emailIdValidation;
        }

        if (typeof fields["emailid"] !== "undefined") {
            if (fields["emailid"].length > 80) {
                formIsValid = false;
                errors["emailid"] = this.props.labelData.emailMaxLength;
            }
        }


        if (typeof fields["emailid"] !== "undefined") {
            //regular expression for email validation
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(fields["emailid"])) {
                formIsValid = false;
                errors["emailid"] = this.props.labelData.emailValidation2;
            }
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }


    render() {
        return (
            <div id="main-registration-container">
                <div id="formdata">
                    <h5><div dangerouslySetInnerHTML = {{__html: this.props.labelData.formHeading}}/></h5>
                    <div dangerouslySetInnerHTML = {{__html: this.props.labelData.introHeading}}/> <br></br>
                    <form method="post" name="userRegistrationForm" onSubmit={this.submituserRegistrationForm} >
                        <label>{this.props.labelData.firstName}</label>
                        <input type="text" name="firstname" value={this.state.fields.firstname} onChange={this.handleChange} />
                        <div className="errorMsg">{this.state.errors.firstname}</div>
                        <label>{this.props.labelData.lastName}</label>
                        <input type="text" name="lastname" value={this.state.fields.lastname} onChange={this.handleChange} />
                        <div className="errorMsg">{this.state.errors.lastname}</div>
                        <label>{this.props.labelData.emailId}</label>
                        <input type="text" name="emailid" value={this.state.fields.emailid} onChange={this.handleChange} />
                        <div className="errorMsg">{this.state.errors.emailid}</div>
                        <input type="submit" className="button" value="Save" />
                    </form>
                </div>
                {this.state.errorMessage && (
                    <div className="userInfo">
                        <div className="grid-container">
                            <div className="columnsystem">
                                <div className="column-12 pre-4" style={{ marginTop: '80px' }}>
                                    <h5>
                                    <p>{this.state.errorMessage}</p>                                   
                                    <a className="link-blue" data-link-type="external" href={`mailto:${'accounts_support@esri.com'}`}>{'Contact Us'}
                                    <calcite-icon class="calcite-link--icon icon-end" aria-hidden="true" icon="arrowRight" scale="s" calcite-hydrated=""></calcite-icon>
                                    </a>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        );
    }
}

export default withRouter(UserFormData);